module.exports = __webpack_public_path__ + "img/introduction_image_one@2x.16031774.png";